import { logos } from 'constants/logos';
import { useRevealGroup } from 'hooks/useReveal';
import './Logos.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Фірмові знаки — ADR-0004, ADR-0008.
 *
 * Було: посилання на завантаження ховалися під плиткою і виїжджали на наведення,
 * тобто на сенсорних екранах були недосяжні без окремої мобільної розкладки;
 * клас `downloaded` навішувався прямими addEventListener у useEffect без зняття.
 * Стало: усі формати видно одразу, стан «завантажено» тримає React.
 */
export default function Logos() {
  const language = useLanguage();
  const gridRef = useRevealGroup('.logo-box', { step: 45 });

  return (
    <article className='logos-catalog section'>
      <div className='container'>
        <header className='logos-head'>
          <h1 className='page-title'>{language === 'en' ? 'Logos' : 'Логотипи'}</h1>
          <p className='lede'>
            {language === 'en'
              ? 'Brand marks of SGOSTU and partner organizations in SVG and PNG.'
              : 'Фірмові знаки СГОСТУ та організацій-партнерів у форматах SVG і PNG.'}
          </p>
        </header>

        <div className='logos-wrapper' ref={gridRef}>
          {logos.map(({ name, png, svg, pngDark, svgDark }) => (
            <div className='logo-box' key={name}>
              <div className='logo-preview'>
                <img src={svg || png} alt={name} className='logo' />
              </div>

              <div className='logo-meta'>
                <h2 className='logo-name'>{name}</h2>
                <div className='logos-download'>
                  {svg && <DownloadLink href={svg} label='SVG' />}
                  {png && <DownloadLink href={png} label='PNG' />}
                  {svgDark && <DownloadLink href={svgDark} label='SVG Dark' />}
                  {pngDark && <DownloadLink href={pngDark} label='PNG Dark' />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </article>
  );
}

function DownloadLink({ href, label }) {
  return (
    <a href={href} download className='logo-download-link'>
      {label}
      <svg width='16' height='16' viewBox='0 0 24 24' aria-hidden='true'>
        <path
          d='M12 4v11m0 0l-4-4m4 4l4-4M5 19h14'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </a>
  );
}
